module.exports = {
  language: 'Chinese',
  applierApplicationCenter: {
    selectCenterTip: ' '
  },
  multiplePage: {
    moreInfomation: ' ',
    recommendedServices: ' '
  },
  checkoutConfirm: {
    ordered: ' ',
    purchased: ' '
  },
  personal: {
    purgePopupContent: '抱歉，由于安全政策，您的申请已被清除，如果您想尽快申请，可以联系我们。'
  },
  login_maximum: {
    errorContent: '抱歉，您今天已达最大登录次数，请次日再试。'
  },
  nationalityKay: 'zh-cn',
  noneSelectedText: '请选择',
  multiselect: {
    deselect: '按 Enter 键移除',
    select: '按 Enter 键选择',
    selected: '已选择'
  },
  enter: ' 进入',
  upload_failed: '上传失败，请重试',
  due_time: '截止日期',
  requirement: '申请需求',
  something_went_wrong_please_retry: '请求出错，请重试。',
  valid_rediret_home_page_popup_content:
    '登录异常，您是否要前往【 {country} - {center} 】主页重新登录？如是，请点击确认；如想更换中心，请点击取消以便重新选择。',
  invalid_rediret_home_page_popup_content: '登录异常，请重新选择申请国家及中心。',
  'Temporarily not available': '暂时不可用',
  'Coming soon': '即将开放'
};
